// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] || chunkId) + "." + {"189":"d586b7868d2e5b7f1262","404":"228cb1635ce66a7d2c56","406":"706b1e2df05e4c3e2dd1","453":"289234b8982c6946d378"}[chunkId] + ".css";
};